import Svg, { Path } from 'react-native-svg'
import type { SvgProps } from 'react-native-svg'

export default function ShareIcon(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M5.59961 12L5.59961 17C5.59961 18.6569 6.94276 20 8.59961 20H15.3996C17.0565 20 18.3996 18.6569 18.3996 17V12M15.1996 7.2L11.9996 4M11.9996 4L8.79961 7.2M11.9996 4V14.4"
        stroke={props.color ?? '#131214'}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
